import { render, staticRenderFns } from "./inspirational-scroll.vue?vue&type=template&id=10af4cc1&"
import script from "./inspirational-scroll.vue?vue&type=script&lang=js&"
export * from "./inspirational-scroll.vue?vue&type=script&lang=js&"
import style0 from "./inspirational-scroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports